/**
 * Application configuration
 * Handles environment-specific settings
 */

// API URL configuration
// In development: use the proxy configured in package.json
// In production: use the environment variable from Azure Static Web App
export const API_URL = process.env.NODE_ENV === 'development'
  ? '' // Empty string means use the proxy from package.json
  : process.env.REACT_APP_MAINDRAW_API_URL || '';

// Environment name
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'Development';

// For debugging
if (process.env.NODE_ENV === 'development') {
  console.log('Running in development mode with proxy');
} else {
  console.log(`Running in ${ENVIRONMENT} environment`);
  console.log(`API URL: ${API_URL}`);
}
